// extracted by mini-css-extract-plugin
export default {"notificationItem":"NotificationsDropdown_notificationItem__048sU","notificationItemNotSeen":"NotificationsDropdown_notificationItemNotSeen__t1HvN"};